'use strict';

var NdArray = require('../ndarray');

module.exports = function flipImage (img) {
  return new NdArray(img.selection.step(null, -1));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/numjs/src/images/flip.js
// module id = 243
// module chunks = 0